import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class ErrorHandlerService {
    constructor(private router: Router) {}

    handleError(error: any) {
        if (error instanceof HttpErrorResponse) {
            this.handleHttpError(error);
        } else {
            this.handleGenericError(error);
        }
    }

    private handleHttpError(error: HttpErrorResponse) {
        console.error('HTTP error:', error);
        
        switch (error.status) {
            case 401:
                // Handle unauthorized
                this.router.navigate(['/auth/login']);
                break;
            case 403:
                // Handle forbidden
                break;
            case 404:
                // Handle not found
                break;
            case 500:
                // Handle server error
                break;
            default:
                // Handle other errors
                break;
        }
    }

    private handleGenericError(error: any) {
        console.error('An error occurred:', error);
        // Add proper error handling
    }
}